import { render, staticRenderFns } from "./agreementContent.vue?vue&type=template&id=f0a2a4e6&scoped=true"
import script from "./agreementContent.vue?vue&type=script&lang=js"
export * from "./agreementContent.vue?vue&type=script&lang=js"
import style0 from "./agreementContent.vue?vue&type=style&index=0&id=f0a2a4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2a4e6",
  null
  
)

export default component.exports